import { render } from "./HrWarnings.vue?vue&type=template&id=557badee&scoped=true"
import script from "./HrWarnings.vue?vue&type=script&lang=js"
export * from "./HrWarnings.vue?vue&type=script&lang=js"

import "./HrWarnings.vue?vue&type=style&index=0&id=557badee&scoped=true&lang=css"
import "@/assets/css/hr-page-shared.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557badee"]])

export default __exports__